import React, { useCallback, useEffect, useState } from 'react';
import { connect, } from 'react-redux';
import { useHistory, Link, } from 'react-router-dom';
import Paper from '@material-ui/core/Paper';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';

import { DEFAULT_PAPER_ELEVATION, } from 'common/constants';
import Button from 'common/components/Button';
import { StoreBasicDataApiStructure, } from 'common/types';
import { SummaryOrderTable, } from './OrderTable';
import SummaryOrderPricePanel from './OrderPricePanel';
import SummaryOrderAcceptance from './OrderAcceptance';
import SummarySellerTilesHeader from './SellerTilesHeader';
import { routes } from '../../../common/routes';
import { checkoutCompleteOperations, } from 'store/ducks/checkoutComplete';
import { repositories, } from 'api';

type Props = {
    updateCheckoutCompleteRequest: Function,
    order: StoreBasicDataApiStructure<repositories.order.OrderType>,
    isLoading: boolean,
};

const SummaryOrderPanel: React.FC<Props> = ({ updateCheckoutCompleteRequest, order, isLoading, }) => {
    const history = useHistory();
    const [termsAcceptanceFieldState, setAcceptance] = useState({
        termsAcceptance: false,
        isTouched: false,
    });

    const goToConfirmation = useCallback(
        () => {
            if (!termsAcceptanceFieldState.termsAcceptance || !termsAcceptanceFieldState.isTouched) {
                setAcceptance((prevState) =>
                    prevState.isTouched ? prevState : { ...prevState, isTouched: true },
                );
                return;
            }

            updateCheckoutCompleteRequest();
        },
        [ termsAcceptanceFieldState.isTouched, termsAcceptanceFieldState.termsAcceptance, updateCheckoutCompleteRequest, ]
    );

    useEffect(
        () => {
            if (!order.isLoading && order.data !== null && termsAcceptanceFieldState.termsAcceptance) {
                history.push({
                    pathname: routes.CONFIRM,
                    state: {
                        referrer: history.location.pathname,
                        termsAcceptance: termsAcceptanceFieldState.termsAcceptance,
                    },
                });
            }
        },
        [ history, order.data, order.isLoading, termsAcceptanceFieldState.termsAcceptance, ]
    );

    return (
        <Box mb={2}>
            <Paper elevation={DEFAULT_PAPER_ELEVATION} square>
                <Box
                    px={{ xs: 0, md: 4 }}
                    py={{ xs: 0, md: 2 }}
                    display="flex"
                    flexDirection="column"
                >
                    <SummarySellerTilesHeader>
                        <Typography variant="h5">Zamówienie</Typography>
                    </SummarySellerTilesHeader>
                    <SummaryOrderTable />
                    <Box px={{ xs: 2, md: 0 }} pb={{ xs: 2, md: 0 }}>
                        <SummaryOrderPricePanel />
                        <SummaryOrderAcceptance
                            termsAcceptanceFieldState={termsAcceptanceFieldState}
                            setAcceptance={setAcceptance}
                        />
                    </Box>
                </Box>
            </Paper>
            <Box my={3}>
                <Divider />
            </Box>
            <Grid container justify="space-between">
                <Button colorTheme="darkgray" size="large" component={Link} to="/checkout/order">
                    Wstecz
                </Button>
                <Button size="large" onClick={goToConfirmation} disabled={isLoading}>
                    Zamawiam i płacę
                </Button>
            </Grid>
        </Box>
    );
};

type MappingType = {
    order: StoreBasicDataApiStructure<repositories.order.OrderType>,
    pendingData: any,
};

const mapStateToProps = ({ order, pendingData, }: MappingType) => ({
    order,
    isLoading: Boolean(pendingData['UPDATE_CHECKOUT_COMPLETE'] || pendingData['FETCH_ORDER']),
});

const mapDispatchToProps = {
    updateCheckoutCompleteRequest: checkoutCompleteOperations.request,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(SummaryOrderPanel);
